<template>
    <div id="GeGHS">
      <span v-for="ghs_nummer in this.ghs_nummern" :key="ghs_nummer.ghs_nummer">
        <GeGHSObj :ghs_nummer="ghs_nummer"/>
      </span>
    </div>
    <Footer backLink="/" />
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import GeGHSObj from "@/components/Gefahrgut/GeGHSObj.vue";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: "GeGHS",
  components: {
    Header,
    Footer,
    GeGHSObj,
  },
  props: {
    
  },
  data() {
    return {
      ghs_nummern: [],
    };
  },
  methods: {

    async getghs_nummern() {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/ghs_nummern'
        );
        console.log(response.data);

        response.data.sort((a,b) => a.ghs_nummer - b.ghs_nummer);

        return response.data;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
  },
  async created(){
    //console.log(this.benutzer.data);
    this.ghs_nummern = await this.getghs_nummern();
  },
  setup() {
  }
};
</script>

<style lang="scss">
#GeGHS{
    //max-height: 500px;
    height: 90vh;
    overflow-y: auto;
}

@media screen and (max-height: 768px) {
  #GeGHS{
    padding-bottom: 10.3vh;
  }
}
</style>